<template>
  <div class="w-full bg-white border-t py-5">
    <div class="w-full md:w-10/12 lg:w-9/12 mx-auto flex flex-wrap items-center justify-center">
      <div class="w-11/12  md:w-9/12 text-center mx-auto">
        <p class="w-full text-center text-2xl font-bold"><span style="color: rgb(242, 19, 93)">á</span>ptitude</p>
        <div class="w-full flex items-center flex-wrap justify-center my-2">
          <vs-button type="" class="text-gray-800 text-xs md:text-sm" >PRIVIACY STATEMENT</vs-button>   
          <vs-button type="" class="text-gray-800 text-xs md:text-sm" >TERMS & CONDITIONS</vs-button>   
          <vs-button type="" class="text-gray-800 text-xs md:text-sm" >COOKIE POLICIES</vs-button>   
          <vs-button type="" class="text-gray-800 text-xs md:text-sm" >ACCESSIBILITY STATEMENT</vs-button>   
          <vs-button type="" class="text-gray-800 text-xs md:text-sm" >SITEMAP</vs-button>   
        </div> 
        <p class="w-full text-gray-800 text-sm ">&copy; áptitude 2021. All Rights Reserved.</p>        
      </div>
    </div>
  </div>
</template>

<script>
export default {

}

</script>

<style>
.text-1xs{
  font-size: 0.5rem;
}

.footer-links:hover{
  color: rgb(242, 19, 93)
}

</style>